<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row class="mx-1">
        <v-col cols="12" class="d-flex justify-space-between align-end flex-wrap pt-0">
            <v-text-field
                class="mr-4"
                color="kbDarkBlueText"
                v-model="search"
                :placeholder="$t('general.search')"
                single-line
                hide-details
                clearable>
                <template #append>
                    <v-icon color="kbDarkBlueText">search</v-icon>
                    <v-tooltip bottom>
                        <template v-slot:activator="{on}">
                            <v-icon class="ml-2"
                                    color="kbDarkBlueText"
                                    v-on="on"
                                    @click="showArchivedCampaign = !showArchivedCampaign">
                                {{showArchivedCampaign ? 'unarchive' : 'archive'}}
                            </v-icon>
                        </template>
                        <span>
                            {{showArchivedCampaign ? $t('general.seeUnarchivedCampaigns') : $t('general.seeArchivedCampaigns')}}
                        </span>
                    </v-tooltip>
                </template>
            </v-text-field>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn :disabled="companyBlocked"
                           color="mainButtons"
                           @click="$router.push('campaigns/newsms')"
                           v-on="on"
                           outlined
                           class="mr-2">
                        {{ $t('general.sendMassSms') }}
                    </v-btn>
                </template>
                <span>{{ companyBlocked ? $t('general.mustChargeBeforeSendingCampaigns') : $t('general.sendSmsCampaignFromFile') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn :disabled="companyBlocked"
                           color="mainButtons"
                           dark
                           ripple
                           @click="$router.push('campaigns/new')"
                           v-on="on">
                        {{ $t('general.createCampaign') }}
                    </v-btn>
                </template>
                <span>{{ companyBlocked ? $t('general.mustChargeBeforeSendingCampaigns') : $t('general.sendCampaignToDirectory') }}</span>
            </v-tooltip>
        </v-col>

        <v-col cols="12" class="text-h6 pb-0">
            <v-data-table :headers="headers"
                          :height="dataTableHeight"
                          fixed-header
                          :items="campaigns"
                          class="elevation-2"
                          :loading="loadingCampaigns"
                          :must-sort="false"
                          :options.sync="options"
                          :footer-props="{
                        'items-per-page-text': `${$t('general.forms')} ${$t('general.perPage')}`,
                        'items-per-page-options': [50, 100, 200]
                      }"
                          :server-items-length="totalCampaigns">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="font-weight-bold text-capitalize">{{ item.name.toLowerCase() }}</td>
                        <td class="text-align-center">{{ item.totalUsers | formatNumber }}</td>
                        <td style="text-transform: capitalize">{{ item.status }}</td>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="kbDarkBlueText" v-on="on" style="cursor:pointer;">
                                        {{ getIconType(item.type) }}
                                    </v-icon>
                                </template>

                                <span style="text-transform: capitalize">{{item.type}}</span>
                            </v-tooltip>
                        </td>

                        <td>{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY') }}</td>

                        <td class="px-0 mx-0">
                            <div class="data-table-actions d-flex justify-center align-center">
                                <v-btn icon @click="showCampaign(item)" color="kbDarkBlueText" text>
                                    <v-icon>remove_red_eye</v-icon>
                                </v-btn>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                        <v-btn v-on="on"
                                               icon
                                               color="kbBlue"
                                               :disabled="exporting !== ''"
                                               :loading="exporting === item._id"
                                               @click="exportCampaign(item)"
                                               text
                                               v-show="item.status === 'sent'">
                                            <v-icon>
                                                fas fa-file-excel
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <span>{{$t('general.export')}}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                        <v-btn v-on="on"
                                               icon
                                               color="kbDarkBlueText"
                                               :loading="archivingCampaign === item._id"
                                               @click="archiveCampaign(item)"
                                               text>
                                            <v-icon>
                                                {{item.archived ? 'unarchive' : 'archive'}}
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <span>{{item.archived ? $t('general.unArchive') : $t('general.archive')}}</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingCampaigns">
                            {{ $t('general.loadingCampaigns') }}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.noCampaignsCreated') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import campaignsService from '@/services/campaignsService'
import messageTypes from '@/libs/messageTypes'
import notifications from '@/libs/notifications'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import TimeZones from '@/mixins/TimeZones'

export default {
  computed: {
    ...mapState({
      campaigns: state => state.campaigns.campaigns,
      language: state => state.auth.language,
      loadingCampaigns: state => state.campaigns.loadingCampaigns,
      paginationCampaigns: state => state.campaigns.paginationCampaigns,
      selectedApp: state => state.apps.selectedApp,
      totalCampaigns: state => state.campaigns.totalCampaigns,
      companyPaymentState: function () {
        return this.$store.getters.companyPaymentState
      },
      companyIsMonthlyBilling: function () {
        return this.$store.getters.companyIsMonthlyBilling
      }
    }),
    search: {
      get () {
        return this.$store.state.campaigns.search
      },
      set (value) {
        this.$store.commit('SET_SEARCH_CAMPAIGNS', value)
      }
    },
    companyBlocked () {
      return this.$store.getters.companyPaymentState === 'block' && !this.$store.getters.companyIsMonthlyBilling
    }
  },
  data () {
    return {
      archivingCampaign: '',
      exporting: '',
      headers: [
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.people'), value: 'totalUsers', align: 'center' },
        { text: this.$t('general.status'), value: 'code' },
        { text: this.$t('general.type'), value: 'type' },
        { text: this.$t('general.creationDate'), value: 'createdAt' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ],
      formId: '',
      options: {},
      selectedForm: {},
      showAttachFormDialog: false,
      showEditFormDialog: false,
      showNewFormDialog: false,
      viewFormDialog: false,
      getIconType: messageTypes.getIconType,
      showArchivedCampaign: false

    }
  },
  methods: {
    async archiveCampaign (campaign) {
      try {
        this.archivingCampaign = campaign._id
        await this.$store.dispatch('archiveCampaign', { campaignId: campaign._id, archiveCampaign: !campaign.archived })
        this.archivingCampaign = ''
        notifications.success(this.$t('general.campaignSuccessfullyArchived'))
        this.getCampaigns()
      } catch (error) {
        this.archivingCampaign = ''
        notifications.error(error.message)
      }
    },
    clearSelectedForm () {
      this.selectedForm = {}
    },
    exportCampaign (campaign) {
      this.exporting = campaign._id
      campaignsService.exportCampaign(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        campaign._id,
        { filename: campaign.name }
      ).then(() => {
        this.exporting = ''
      }).catch((error) => {
        notifications.error(error.message)
        this.exporting = ''
      })
    },
    showAttachForm (formId) {
      this.$store.commit('SET_FORM_ID', formId)
      this.showAttachFormDialog = true
    },
    showCampaign (item) {
      this.$router.push('campaigns/' + item._id)
    },
    showEditForm (index) {
      this.selectedForm = index
      this.showEditFormDialog = true
    },
    showForm (form) {
      this.$store.dispatch('getForm', form._id)
      this.viewFormDialog = true
    },
    getCampaigns () {
      const newoptions = Object.assign({}, { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.commit('SET_PAGINATION_CAMPAIGNS', newoptions)
      this.$store.dispatch('getCampaigns', { archivedCampaign: this.showArchivedCampaign })
    }
  },
  mixins: [ModuleTableHeight, TimeZones],
  watch: {
    language () {
      this.headers[0].text = this.$t('general.name')
      this.headers[1].text = this.$t('general.people')
      this.headers[2].text = this.$t('general.status')
      this.headers[3].text = this.$t('general.type')
      this.headers[4].text = this.$t('general.creationDate')
      this.headers[5].text = this.$t('general.actions')
    },
    options: {
      handler () {
        this.getCampaigns()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.getCampaigns()
    },
    selectedApp () {
      this.$store.dispatch('getCampaigns', { archivedCampaign: this.showArchivedCampaign })
    },
    showArchivedCampaign () {
      this.options = {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: []
      }
    }
  }
}
</script>
